


import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';

import { LoggedUser } from './../../../_models/';

@Component({
    templateUrl: 'vehicletaskList.component.html',
  standalone: false
})
export class VehicleTaskListComponent implements OnInit {
    loggedUser: LoggedUser;
    constructor(private fb: FormBuilder) {}

    ngOnInit(): void {document.querySelector("body").classList.remove("opened");}
}
